/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import MDBox from "dashboard-template/components/MDBox";
import MDTypography from "dashboard-template/components/MDTypography";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import GeneralSettingsForm from "components/forms/GeneralSettingsForm";

/**
 * Props for GeneralSettingsModal component
 */
interface GeneralSettingsModalProps {
    open: boolean;
    onClose: () => void;
}

/**
 * Modal component for creating/updating general system settings.
 * 
 * Features:
 * - Country selection
 * - Language preference
 * - Currency configuration
 * - Insurance module toggle
 * - Pharmacy module toggle
 * - Office visit module toggle
 * - Simplified system mode toggle
 * - Default appointment duration
 * - Videochat enabled time
 * - Form validation with Yup
 * - Internationalization support
 * 
 * @param open - Controls modal visibility
 * @param onClose - Callback when modal is closed
 * @param onSave - Callback when form is submitted with valid data
 * @param isLoading - Loading state for submit button
 */
/**
 * Modal component for managing general system settings.
 * 
 * This modal wraps the GeneralSettingsForm component to provide
 * a dialog interface for configuring system-wide settings.
 * 
 * @param open - Controls modal visibility
 * @param onClose - Callback when modal is closed
 */
const GeneralSettingsModal: FC<GeneralSettingsModalProps> = ({
    open,
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth className="general-settings-modal">
            <DialogTitle className="general-settings-modal__title">
                <MDTypography variant="h4">{t("generalSettingsModal.title")}</MDTypography>
                <MDTypography variant="body2" className="general-settings-modal__subtitle">
                    {t("generalSettingsModal.subtitle")}
                </MDTypography>
            </DialogTitle>
            <DialogContent>
                <MDBox>
                    <GeneralSettingsForm isModal={true} />
                </MDBox>
            </DialogContent>
        </Dialog>
    );
};

export default GeneralSettingsModal;
